<!--suppress JSNonASCIINames -->
<template>
  <div>
    <p v-if="0 < is위험도20.length" class="flex justify-end items-center" style="color: #ea5455">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.79995 5.8C9.79995 5.35817 9.44178 5 8.99995 5C8.55812 5 8.19995 5.35817 8.19995 5.8V9C8.19995 9.44183 8.55812 9.8 8.99995 9.8C9.44178 9.8 9.79995 9.44183 9.79995 9V5.8ZM8.99597 11.4C8.55634 11.4 8.19995 11.7582 8.19995 12.2C8.19995 12.6418 8.55634 13 8.99597 13H9.00393C9.44356 13 9.79995 12.6418 9.79995 12.2C9.79995 11.7582 9.44356 11.4 9.00393 11.4H8.99597Z"
          fill="#EA5455"
        />
      </svg>
      위험도 20점 이상 건이 있습니다. 담당임원에게 결재 바랍니다.
    </p>

    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :fieldReadonly="board.readonly"
      :board="board"
      :is-print="isPrint"
      :vislbleAlert="true"
      :types="['field_name', 'order_company', 'com_name', 'writer_name', 'date']"
      :typeslabel="{
        com_name: '업체명',
        order_company: '발주부서',
      }"
      :options="[
        { type: 'text', label: '허가번호', readonly: true, visibleWhenValue: true },
        { type: 'text', label: '문서번호', readonly: true, visibleWhenValue: true },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      @selectField="selectField"
    />

    <vs-tabs v-if="!isPrint" v-model="currTab">
      <vs-tab label="작업허가서 정보(신청자)"> </vs-tab>
      <vs-tab label="비일상 위험성평가 정보(단위부서)"> </vs-tab>
      <vs-tab label="사외수급업체 서류평가(안전환경팀)"> </vs-tab>
    </vs-tabs>

    <!-- LV1 -->
    <FormLv1 v-show="isPrint || currTab === 0" ref="form1" :readonly="board.readonly" :board="board" :isPrint="isPrint" v-model="form" class="mt-2" />

    <!-- LV2 -->
    <FormLv2 v-show="isPrint || currTab === 1" :readonly="board.readonly || board.isWriter" ref="form2" :board="board" :isPrint="isPrint" v-model="form" class="mt-2" />

    <!-- LV3 -->
    <FormLv3 v-show="isPrint || currTab === 2" :readonly="board.readonly || board.isWriter || !결재선에서_현재_결재자가_처리부서_소속인가" ref="form3" :board="board" :isPrint="isPrint" v-model="form" class="mt-2" />

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />

    <vs-popup :active.sync="warning20" title="알림">
      <div>
        <table>
          <tr>
            <th style="color: #e42728">
              <div class="flex items-center justify-center">
                <feather-icon class="mr-2" icon="AlertCircleIcon" />
                <span>평가결과 20점 이상</span>
              </div>
            </th>
          </tr>
          <tr>
            <td>
              <div>※ 중요위험(허용불가능) 위험입니다, 즉시개선하십시오.</div>
              <div>※ 담당임원에게 결재 바랍니다.</div>
            </td>
          </tr>
        </table>
      </div>
    </vs-popup>
  </div>
</template>

<script>
/* eslint-disable brace-style */
import FormLv1 from "./FormLv1.vue";
import FormLv2 from "./FormLv2.vue";
import FormLv3 from "./FormLv3.vue";

import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";

import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

import RadioTypeCheck from "@/components/radio/RadioTypeCheck.vue";
import FileDownloadPost from "@/components/FileDownloadPost.vue";
import NumberInput from "@/components/NumberInput.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector";
import FileUploader from "@/components/FileUploader.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang";

import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import { required } from "vuelidate/lib/validators";
import HttpRequest from "@/util/HttpRequest";

export default {
  components: {
    FormLv1,
    FormLv2,
    FormLv3,
    FieldSelectModule,
    FileUploadModule,
    WriteGridContainer,
    PrintCheckbox,
    RadioTypeCheck,
    FileDownloadPost,
    NumberInput,
    DateSelector,
    CustomOptionSelector,
    FileUploader,
    RadioGroup,
    DateSelectorRang,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
    oldForm: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
      보험자료확인사항: {
        산재보험서류: { required },
        안전보건관리계획서: { required },
      },
      출입작업시필수안전조치: { required },
    },
  },
  data() {
    return {
      currTab: 0,
      warning20: false,
      isLoadMemberListInfo: false, // 공사인원 정보 한번만 검색하기 위함

      form: {
        stdInfo: {},
        fileList: [],

        // LV1
        안전작업허가서정보: {
          공장명: "",
          작업기간: "",
          공사금액: "",
          작업업체명: "",
          작업자: "",
          산업안전관리비: "",
          _작업구역: { region: { id: null, name: "" }, zone: { id: null, name: "" } },
          _작업구역수동입력: "",
          공사작업명: "",
          세부작업내용: "",
        },
        보험자료확인사항: {},
        안전관계자: {
          동국제강: { id: 0, name: "", phone: "" },
          공사업체: [{ id: 0, name: "", phone: "" }],
          확인자유무: "",
          확인자: "",
          확인자서명: { sign: "" },
        },

        공사인원Table: [],
        공사인원: {
          총인원: 0,
          업체비상연락처: "",
          DKS발주부서장확인서: null, // 65세 이상 확인서 첨부
        },
        출입작업시필수안전조치: false,

        // LV2
        위험성평가정보: {},
        공정분류: { raw: null, 대분류: "", 중분류: "", 소분류: "", 구분: "", 아차사고: "N" },
        작업빈도일: "",
        작업빈도주: "",
        작업빈도월: "",
        작업빈도분기: "",
        작업빈도년: "",
        작업빈도작업시간: "",
        담당: {},
        동일직무인원: {},
        위험성평가표: {
          위험도: "",
          중요위험: "",
          data: [{ id: 1, 검토1차: "Y", 검토2차: "Y" }],
        },

        안전보호구: "",
        정리정돈사항: "",
        ONEPOINT: "",
        일반작업: false,
        보충항목: [],
        환경RISK검토해당: "해당없음",
        환경RISK검토: [],
        중요위험해당여부: "",

        중요위험: [],

        // LV3
        처리부서등록: false,
      },

      // 현재 로그인한 사용자가 결재선에 있는 경우, 해당 결재선의 사용자 정보가 담긴다.
      현재결재자정보: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.auth.userInfo;
    },
    postId() {
      return this.$route.params.postId;
    },
    is위험도20() {
      return this.form.위험성평가표.data.filter((data) => 20 <= data.위험도);
    },
    has65세() {
      return (
        this.form.공사인원Table.filter((data) => {
          const 생년월일 = data.생년월일;
          let is65 = false;
          if (생년월일) {
            const currentYear = new Date().getFullYear();
            const currentCentury = Math.floor(currentYear / 100) * 100; // 현재 세기의 시작 (예: 2000, 1900)
            let birthYear = parseInt(생년월일.substring(0, 2), 10);
            birthYear += birthYear <= currentYear % 100 ? currentCentury : currentCentury - 100;
            const age = currentYear - birthYear - 1;
            is65 = age >= 65;
          }
          return is65;
        }).length > 0
      );
    },
    결재선에서_현재_결재자() {
      if (!this.board.approvalLine) {
        return null;
      }
      return this.board.approvalLine.find((item) => item.user_id === this.userInfo.id && item.status === "waiting");
    },
    결재선에서_현재_결재자가_처리부서_소속인가() {
      // 결재선에 처리부서 담당자가 지정된 상태로 저장됐다면, 처리부서 소속도 결재선에 존재할 수 있다.
      if (this.현재결재자정보) {
        // 처리부서 ID 값이 존재한다면, 처리부서 사용자인 것으로 판단한다.
        return !!this.현재결재자정보.document_company_id;
      }

      // 만약 최초로 결재하는 처리부서 담당자일 경우, 아직 결재선에 등록되어 있지 않은 상태다.
      // 이 경우, 처리부서의 virtual_company_id 값과 나의 virtual_company_id 값을 비교한다.
    },
    내가_현재_결재순서인가() {
      // turnApprovalId 값이 존재할 경우, 현재 사용자의 id와 비교한다.
      if (this.board.turnApprovalId) {
        return this.userInfo.id === this.board.turnApprovalId;
      }
      // 결재부서에 담당자가 지정되지 않은 경우, turnApprovalId 값이 존재하지 않는다.
      // 이 경우, 처리부서의 virtual_company_id 값과 나의 virtual_company_id 값을 비교한다.
      else {
        return this.userInfo.virtual_company_id === this.board.documentCompany.virtual_company_id;
      }
    },
  },
  watch: {
    "value": {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (typeof this.form.안전작업허가서정보.작업구역 === "object") this.form.안전작업허가서정보.작업구역 = this.form.안전작업허가서정보.작업구역.zone.name;
      },
    },
    "form": {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    "form.공사인원Table": {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.length > 0 && !this.isLoadMemberListInfo) {
          const target = [];
          for (const item of value) {
            target.push(item.userId);
          }

          this.loadMemberListInfo(target);
          this.isLoadMemberListInfo = true;
        }
      },
    },
    "board.approvalLine": {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.length > 0) {
          // status_code 가 wait 인 결재자를 찾는다
          this.현재결재자정보 = value.find((item) => item.user_id === this.userInfo.id && item.status_code === "wait" && Number(item.type_id) === 3);
        }
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }

      // const 기안자 = this.board.approvalLine.find((item) => item.user_id === this.board.writer.id);
      // const 기안자_user_id = 기안자 ? 기안자.user_id : undefined;
      // const 현재_결재자_user_id = 현재_결재자 ? 현재_결재자.user_id : undefined;
      // const 현재_결재자가_기안자인지 = 기안자_user_id && 현재_결재자_user_id && 기안자_user_id === 현재_결재자_user_id;

      // 1탭 : 최초결재자(기안자)가 모두입력(필수입력필드화), 안되어있으면 기안 안되도록
      if (!this.postId || this.board.statusCode === "temp") {
        const _vF1 = this.$refs.form1.validate();
        if (_vF1) return _vF1;
      } else {
        if (this.내가_현재_결재순서인가 === false) {
          return "결재순서가 아닙니다. 결재자에게 확인하세요.";
        }

        // 2번째 탭 처리
        if (this.결재선에서_현재_결재자가_처리부서_소속인가 === false) {
          const _vF2 = this.$refs.form2.validate();
          if (_vF2) return _vF2;

          if (0 < this.is위험도20.length) {
            this.warning20 = true;
            return {
              type: "write-custom-alert",
              success: false,
            };
          }
        }
        // 3번째 탭 처리
        else {
          // 897번 등록글 서류평가합산 조회
          const _vF3 = this.$refs.form3.validate();
          if (_vF3) return _vF3;
        }
      }
      // // 2탭 : 두번째 결재자(첫번째 승인자)가 모두입력(필수입력필드화), 안되어 있으면 승인 안되도록
      // // else if (this.board.approvalLine[1] && this.board.approvalLine[1].user_id === this.board.turnApprovalId) {
      // else if (this.board.approvalLine[1] && this.board.approvalLine[1].user_id === this.board.turnApprovalId) {
      //   const _vF2 = this.$refs.form2.validate();
      //   if (_vF2) return _vF2;
      //
      //   if (0 < this.is위험도20.length) {
      //     this.warning20 = true;
      //     return {
      //       type: "write-custom-alert",
      //       success: false,
      //     };
      //   }
      // }
      // // 3탭 : 처리부서가 입력 하지 않으면 결재 진행 안되도록(필수입력필드화)
      // else {
      //   // 결재자가 처리부서인지 검색
      //   // const matchedData = this.board.approvalLine.filter((item) => item.document_company_id && item.user_id === this.board.turnApprovalId);
      //   //
      //   // if (matchedData.length > 0) {
      //   //   const _vF3 = this.$refs.form3.validate();
      //   //   if (_vF3) return _vF3;
      //   // }
      //
      //   // 897번 등록글 서류평가합산 조회
      //   const _vF3 = this.$refs.form3.validate();
      //   if (_vF3) return _vF3;
      // }

      if (this.has65세 && this.form.공사인원.DKS발주부서장확인서 && !this.form.공사인원.DKS발주부서장확인서.id) {
        return "만 65세 이상 인원이 있습니다.<br>DKS 발주부서장 확인서를 첨부해주세요.";
      }
    },

    onClickTab(i) {
      this.currTab = i;
    },

    selectField() {
      if (this.form.stdInfo.field_name) {
        this.$refs.form1.set작업구역(this.form.stdInfo.field_name);
      }
    },

    transformToMeta(metas) {
      const meta = {};

      metas.forEach(({ meta_key, meta_value }) => {
        const keys = meta_key.split(".");
        let current = meta;

        // Traverse or create nested objects
        keys.forEach((key, index) => {
          if (index === keys.length - 1) {
            // Check if value is numeric and convert
            current[key] = /^\d+$/.test(meta_value) ? Number(meta_value) : meta_value;
          } else {
            if (!current[key]) {
              current[key] = {}; // Create a new object if not exists
            }
            current = current[key];
          }
        });
      });

      return meta;
    },

    async loadMemberListInfo(userIds) {
      await HttpRequest.get("/api/v1/member", {
        params: {
          projectId: this.$route.params.proj_id,
          userIds,
          page: 1,
          perPage: 10000,
        },
      })
        .then((response) => {
          const userIdToMetasMap = new Map();
          const userIdToDatasMap = new Map();

          for (const item of response.data) {
            if (item.metas.length > 0) {
              userIdToMetasMap.set(item.id, this.transformToMeta(item.metas));
            }

            const rank = item.rank ? item.rank : "";
            userIdToDatasMap.set(item.id, {
              rank,
            });
          }

          for (const member of this.form.공사인원Table) {
            if (userIdToMetasMap.has(member.userId)) {
              const metas = userIdToMetasMap.get(member.userId);
              const 생년월일 = metas.rrn ? `${metas.rrn}`.padStart(7, "0").slice(0, -1) : "";
              member.생년월일 = 생년월일;
            }

            // 직위는 회원가입시 입력하는 직책과 다를 수 있어서 값을 받아오지 않음
            // if (userIdToDatasMap.has(member.userId)) {
            //   const data = userIdToDatasMap.get(member.userId);
            //   member.직위 = member.직위 && member.직위!== ""? member.직위 : data.rank
            // }
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  &,
  th,
  td {
    font-size: 14px;
    text-align: center;
    background: white;
    border: 1px solid #cdcdcd;
    padding: 7px;
  }

  th {
    font-weight: 700;
    background: #f9f9f9;
    padding: 16px 0;
  }

  td {
    font-weight: 400;
  }
}
</style>
